import React from 'react';
import { useIsXSmallResolution } from '../../../../hooks/use-is-xsmall-resolution.js';
import { ContextMenu } from '../../../context-menu/context-menu.js';
import { Option } from '../../../option/option.js';
function MobileActions(props) {
    const { deleteOptionEnabled, downloadOptionEnabled, onDelete, onDownload, onPrint, printOptionEnabled, showControls } = props;
    const allOptionsDisabled = !printOptionEnabled && !downloadOptionEnabled && !deleteOptionEnabled;
    const isXSmallResolution = useIsXSmallResolution();
    if (!isXSmallResolution || !showControls || allOptionsDisabled) {
        return null;
    }
    return (React.createElement(ContextMenu, { className: "c-media-container__context-menu", uuid: "c-media-container__context-menu" },
        React.createElement(Option, { enabled: printOptionEnabled, onClick: onPrint, preventDefault: true, stopPropagation: false, value: "tws.media-container.print" }),
        React.createElement(Option, { enabled: downloadOptionEnabled, onClick: onDownload, preventDefault: true, stopPropagation: false, value: "tws.media-container.download" }),
        React.createElement(Option, { enabled: deleteOptionEnabled, onClick: onDelete, preventDefault: true, stopPropagation: false, value: "tws.media-container.delete" })));
}
export { MobileActions, };
//# sourceMappingURL=mobile-actions.js.map